import { useRef, useState, useEffect } from "react";
import Button from "../../../../..//Elements/Button/Button.js";
import apiRequest from "../../../../../../utils/ApiRequest/apiRequest.js";
import Recaptcha from "components/Reusable/Recaptcha/Recaptcha.tsx";
import { useModal } from "../../../../../../contexts/modalContext/modalContext.js";
import { useContent } from "../../../../../../contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";
import { awaiter } from "components/Pages/Home/Helpers/helpers.js";
import { RECAPTCHA_APPEAR_DELAY } from "utils/globalConsts.ts";
import { useRateLimitError } from "hooks/useRateLimitError.ts";

//RecoverPasswordReact
const RecoverPasswordModal = ({ userData }) => {
  const { closeModal } = useModal();
  const { addToast } = useToasts();
  const { getTextByKey, getLanguageCulture, getBasicSettingsData } =
    useContent();

  const [showRecaptcha, setShowRecaptcha] = useState(false);

  const [captchaToken, setCaptchaToken] = useState(null);

  const [loading, setLoading] = useState(false);

  const recaptchaRef = useRef(null);

  const { isRateLimitError, rateLimitError } = useRateLimitError();

  const replaceUsrMail = () => {
    let text = getTextByKey("profileuserdetails-forgot-password-send-mail");
    text = text.replace("#USEREMAIL#", userData.UserName);
    return text;
  };

  //send mail to recover password
  const recoverPassword = async (withCaptcha = false) => {
    setLoading(true);
    setShowRecaptcha(true);

    if (getBasicSettingsData().recaptchaType === "google" && !captchaToken) {
      await awaiter(RECAPTCHA_APPEAR_DELAY);
      await recaptchaRef.current.executeAsync();

      return;
    }

    if (!withCaptcha) {
      return;
    }

    if (!captchaToken && withCaptcha) {
      addToast(getTextByKey("recaptcha-verification-error"), {
        appearance: "error",
      });
      setLoading(false);
      return;
    }

    const parameters = {
      userEmail: userData.UserName,
      didRecaptcha: true,
      culture: getLanguageCulture(),
      captchaServiceName: "google",
      recaptchaResponse: captchaToken,
    };
    const response = await apiRequest(
      "Users",
      "RecoverPasswordUserRequestReact",
      parameters
    );
    if (response.status === "success") {
      if (response.data) {
        addToast(getTextByKey("profileuserdetails-successfully-sent"), {
          appearance: "success",
        });
      }
    }
    if (response.status === "error") {
      let message = getTextByKey(
        "profileuserdetails-unable-to-send-password-mail"
      );

      if (isRateLimitError(response)) message = rateLimitError;

      addToast(message, {
        appearance: "error",
      });
    }
    setLoading(false);
    closeModal();
  };

  useEffect(() => {
    if (captchaToken) {
      recoverPassword(true);

      setCaptchaToken(null);
      setShowRecaptcha(false);
    }
  }, [captchaToken]);

  return (
    <div className="recover-password-modal">
      <div className="top-section">
        <div className="modal-content">
          <div className="modal-body">
            <div>
              <p>{replaceUsrMail()}</p>
            </div>
            <div className="actions">
              <Button
                buttonClass="recover-cancel-button"
                blank
                onClick={() => {
                  closeModal();
                }}
              >
                {getTextByKey("jumboforms-delete-form-cancel")}
              </Button>
              <Button
                buttonClass="recover-link-button"
                disabled={loading}
                onClick={() => {
                  recoverPassword();
                }}
              >
                {getTextByKey("profileuserdetails-forgot-password-ok")}
              </Button>
            </div>
            {showRecaptcha && (
              <Recaptcha
                recaptchaRef={recaptchaRef}
                onSuccess={(token) => {
                  setCaptchaToken(token);
                }}
              />
            )}
          </div>
        </div>
      </div>
      <div className="bottom-section"></div>
    </div>
  );
};

export default RecoverPasswordModal;
